const dropdownMenus = document.querySelectorAll('.js-dropdown-menu');
dropdownMenus.forEach((menuTrigger) => {
	// Toggle dropdown function
	const toggleDropdown = () => {
		dropdownMenus.forEach((menu) => {
			if (menu !== menuTrigger) {
				menu.classList.remove('is-open');
			}
		});

		menuTrigger.classList.toggle("is-open");
	};

	// Toggle dropdown open/close when dropdown button is clicked
	menuTrigger.querySelector('a').addEventListener("click", (e) => {
		e.preventDefault();
		toggleDropdown();
	});

	// Close dropdown when dom element is clicked
	document.documentElement.addEventListener("click", (e) => {
		if (e.target !== menuTrigger && ! menuTrigger.contains(e.target)) {
			if (menuTrigger.classList.contains("is-open")) {
				toggleDropdown();
			}
		}
	});
});
